import React from "react";

const Select = ({
  label,
  name,
  value,
  id,
  onChange,
  className,
  options,
  disabled,
}) => {
  return (
    <>
      {label && <label htmlFor={label}>{label}</label>}
      <select
        name={name}
        id={id}
        onChange={onChange}
        value={value}
        className={className}
        disabled={disabled}
      >
        {options.map((d, i) => (
          <option key={i + 1} value={d}>
            {d}
          </option>
        ))}
      </select>
    </>
  );
};

export default Select;
